module.exports = __webpack_public_path__ + "static/media/intesa.7903d549.png";